import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "./utils";

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;
export const DialogPortal = DialogPrimitive.Portal;

export const DialogOverlay = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn(
      "tw-fixed tw-inset-0 tw-z-[1060] tw-bg-slate-900/40 data-[state=open]:tw-animate-d2c-fade-in",
      className,
    )}
    {...props}
  />
));
DialogOverlay.displayName = "DialogOverlay";

// Centred dialog. "d2c-ui" lets the page's scoped border rule reach the portal.
export const DialogContent = React.forwardRef(({ className, children, hideClose, ...props }, ref) => (
  <DialogPortal>
    <DialogOverlay />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        "d2c-ui tw-fixed tw-left-1/2 tw-top-1/2 tw-z-[1061] tw-grid tw-w-[calc(100%-2rem)] tw-max-w-lg -tw-translate-x-1/2 -tw-translate-y-1/2 tw-gap-4 tw-rounded-lg tw-border tw-bg-background tw-p-6 tw-font-sans tw-text-sm tw-leading-5 tw-text-foreground tw-shadow-lg data-[state=open]:tw-animate-d2c-pop-in",
        className,
      )}
      {...props}
    >
      {children}
      {!hideClose && (
        <DialogPrimitive.Close className="tw-absolute tw-right-4 tw-top-4 tw-cursor-pointer tw-rounded-sm tw-bg-transparent tw-p-0.5 tw-text-muted-foreground tw-opacity-70 tw-transition-opacity hover:tw-opacity-100 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring">
          <X className="tw-size-4" aria-hidden="true" />
          <span className="tw-sr-only">Close</span>
        </DialogPrimitive.Close>
      )}
    </DialogPrimitive.Content>
  </DialogPortal>
));
DialogContent.displayName = "DialogContent";

export const DialogHeader = ({ className, ...props }) => (
  <div className={cn("tw-flex tw-flex-col tw-gap-1.5 tw-pr-6", className)} {...props} />
);

export const DialogFooter = ({ className, ...props }) => (
  <div className={cn("tw-flex tw-flex-col-reverse tw-gap-2 sm:tw-flex-row sm:tw-justify-end", className)} {...props} />
);

export const DialogTitle = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Title
    ref={ref}
    className={cn("tw-m-0 tw-font-sans tw-text-base tw-font-semibold tw-leading-6 tw-text-foreground", className)}
    {...props}
  />
));
DialogTitle.displayName = "DialogTitle";

export const DialogDescription = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Description ref={ref} className={cn("tw-m-0 tw-text-sm tw-text-muted-foreground", className)} {...props} />
));
DialogDescription.displayName = "DialogDescription";
